module.exports = __webpack_public_path__ + "img/icon_unselected_wanlong.90e43b2a.png";